import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-cbta-slider",
	templateUrl: "./cbta-slider.component.html",
	styleUrls: ["./cbta-slider.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaSliderComponent implements OnInit {
	@Input() currentSliderValue: number = 0;
	@Input() steps: number = 5;

	@Output() sliderChange = new EventEmitter<number>();

	constructor() {}

	ngOnInit(): void {}

	onSliderDrag(value: number) {
		this.currentSliderValue = value;
		this.sliderChange.emit(value);
	}

	// Generate an array of numbers from 0 to steps
	get stepsArray(): number[] {
		return Array(this.steps + 1)
			.fill(0)
			.map((x, i) => i);
	}
}
